import actions from './actions'
import mutations from './mutation'

const state = {
  rustTab: 'contract',
  solidityTab: 'contract'
}

export default {
  state,
  actions,
  mutations
}
